var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"height":"100%","display":"flex","align-items":"center","justify-content":"center"}},[(_vm.form === 'login')?_c('LoginForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }